import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import $ from 'jquery';

// QR Payment
import QRCode from "qrcode.react";
import { pusherChanelForQR } from "../../utils/pusher";

// CSS
import "./payment.css";

// Logos & Images

import STPayLogo from "./../../ST-Pay-Logo-v2.png";
import CancelIcon from './../../icons/cancel.png';
import InfoIcon from './../../icons/info.png';
import SuccessIcon from './../../icons/success.png';
import WarningIcon from './../../icons/warning.png';
// import loaderBG from './../../icons/loader-cloud.svg';
// import loaderPlane from './../../icons/loader-plane.svg';
import loader from './../../icons/loader.svg';
import qr_image from './../../icons/qr_code.png';

// Payment icons
import STPayIcon from './../../icons/payment/stpay.png';
import VisaIcon from './../../icons/payment/visa.png';
import MastercardIcon from './../../icons/payment/mastercard.png';
import AmexIcon from './../../icons/payment/amex.png';
import NagadIcon from './../../icons/payment/nagad.png';


import MerchantDetailsService from '../../services/MerchantDetails.service';
import { Link } from 'react-router-dom';
import axios from 'axios';

import { useSnackbar } from "react-simple-snackbar";
import StyledQRCode from '../../services/StyledQRCode';
import CustomQRCode from '../../services/CustomQRCode';



export default function Init() {

    const [currentPage, setCurrentPage] = useState("step1");

    const [tokenizedPaymentKey, setTokenizedPaymentKey] = useState("");
    const [isOtpRequired, setIsOtpRequired] = useState(true);
    const [paymentToken, setPaymentToken] = useState("");
    const [info, setInfo] = useState([]);


    const [isSaved, setIsSaved] = useState(false);
    const [isShowSavedAccount, setIsShowSavedAccount] = useState(false);
    const [savedWalletAgreement, setSavedWalletAgreement] = useState(false);
    const [userWalletBalance, setUserWalletBalance] = useState(null);
    const [selectedPaymentOption, setSelectedPaymentOption] = useState("");


    // Popup alerts / info
    const [openSnackbar, closeSnackbar] = useSnackbar({
        position: "top-right",
        style: {
            backgroundColor: "#e67e22",
            color: "#fff",
            fontSize: "16px",
            textAlign: "center"
        }
    });

    // Response Box : 0=>error, 1=>processing, 2=>success
    const [warningBox, setWarningBox] = useState({
        status: 1,
        show: true,
        title: "Please Wait!",
        message: "Payment information is being processed.",
        otpInvalid: false
    });


    const [isResendOtp, setIsResendOtp] = useState(false);

    const [phone, setPhone] = useState("");
    const [maskingPhone, setMaskingPhone] = useState("");

    const enterPhone = (event) => {

        let v = event.value.replace(/\D/g, '').toString() ?? "";
        if( v.length > 11 ) {
            return;
        }

        if( v[0] !== "0" ) {
            setPhone("");
            return;
        }

        if (v.length > 7) {
            v = `${v.slice(0, 4)} ${v.slice(4, 7)} ${v.slice(7)}`;
        } else if (v.length > 4) {
            v = `${v.slice(0, 4)} ${v.slice(4)}`;
        } 

        setPhone(v);
    }

    // Show Insufficient Balance Pop-up
    const [showCards, setShowCards] = useState(false);

    // Initiation Mode
    const [isQrPayment, setIsQrPayment] = useState(false);
    useEffect(()=>{
        if( $(window).width() < 560 ) {
            setIsQrPayment(false);
        }
    }, [$(window).width()]);


    useEffect(()=> {
        const url = window.location;
        const token = new URLSearchParams(url.search).get("token") ?? "";
        if(token?.length === 0) {
            showErrorMessages(406);
            return;
        }

        if( token ) {
            fetchData(token);
            setPaymentToken(token);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const fetchData = async (token) => {
        try {
            const res = await MerchantDetailsService.getSummery(token);
            if (res.data.code === 200) {
                setInfo(res?.data?.data);
                setWarningBox({...warningBox, show: false});

                setTimeout(()=>{
                    $("#phone_input").focus();
                }, 1000);


                // Set Pusher For QR Payment
                pusherChanelForQR(
                    res?.data?.data.order.event,
                    res?.data?.data.order.channel,
                    res?.data?.data,
                    "qr"
                );

                return;
            }
            
            showErrorMessages(406);
        }
        catch(error) {
            showErrorMessages(406);
        }
    }


    // Timer
    const [time, setTime] = useState(process.env.REACT_APP_PAYMENT_GATEWAY_EXPIRE_TIMER);
    useEffect(() => {
        if (time <= 0) {
            // window.location.assign(info.merchant.redirect_urls.cancel + "?order_id=" + info?.order?.id);
            return;
        };

        const timerId = setInterval(() => {
            setTime(prevTime => prevTime - 1);
        }, 1000);

        return () => clearInterval(timerId);
    }, [time]);


    const [otpTime, setOtpTime] = useState(process.env.REACT_APP_RESEND_OTP_TIMER);
    useEffect(() => {
        if (otpTime <= 0) {
            return;
        };

        const timerId = setInterval(() => {
            setOtpTime(prevTime => prevTime - 1);
        }, 1000);

        return () => clearInterval(timerId);
    }, [otpTime]);

    
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(1)}:${seconds.toString().padStart(2, '0')}`;
    };

    
    const handleCancel = () => {
        let order_id = info?.order?.id ?? "";
        if( order_id === "" ) {
            window.location.assign(process.env.REACT_APP_ST_URL);
            return;
        }

        let c_url = new URL(info.merchant.redirect_urls.cancel);
        c_url.searchParams.append("order_id", order_id);
        window.location.assign(c_url);
    };

    const handleTryAgain = () => {
        document.location.reload();
    }

    const handleConfirm = async () => {

        // OTP page submit 
        if( currentPage === 'step2' ) {
            if( tokenizedPaymentKey?.length === 0 ) {
                handleOtpConfirm();
                return;
            }

            handleTokenOtpConfirm();
            return;
        }


        // PIN page submit
        if( currentPage === 'step3' ) {
            // Regular
            if(tokenizedPaymentKey?.length === 0) {
                handlePinConfirm();
                return;
            }
            
            if( isOtpRequired === false ) {
                handlePinConfirmWithoutOtp();
                return;
            }

            handlePinConfirmWithOtp();
            return;
        }


        if(isQrPayment) {
            openSnackbar('Please select "Use ST Pay Account No." tab !');
            return;
        }

        let mobile_number = "+88" + phone?.replaceAll(" ","");
        if( mobile_number.length !== 14 ) {
            openSnackbar("Please enter valid phone number.");
            setTimeout(()=>{ $("#phone_input").focus() }, 1000);
            return;
        }

        setMaskingPhone(mobile_number?.substring(3,7)+"****"+mobile_number?.substring(11));
        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            mobile_number: mobile_number,
            is_save: (isSaved ? 1 : 0)
        };

        await setWarningBox({
            ...warningBox, 
            status: 1,
            show: true,
            title: "Please Wait!",
            message: "Request is being processed."
        });

        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/send-otp`,
                payload
            );

            setWarningBox({...warningBox, show: false});
            if(res?.data?.code === 200) {
                setOtpTime(process.env.REACT_APP_RESEND_OTP_TIMER);
                setCurrentPage("step2");
                setTimeout(()=>{
                    $("#otp-0").focus();
                }, 1000);
            }
        }
        catch (error) {
            if( error?.response?.data?.message === "The given data was invalid.") {
                return showErrorMessages(404);
            }

            let message = error?.response?.data?.messages?.[0] ?? error?.response?.data?.message ?? "Sorry ! Could not proceed right now. Please try again.";
            showErrorMessages(422, message,error?.code);
            return;
        }
    }


    // OTP Handler
    const [otp, setOtp] = useState(new Array(6).fill(""));
    var handleOtpChange = (element, index) => {
        if(isNaN(element.value)) {
            return false;
        }

        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.value !== "" && element.parentNode.nextSibling) {
            element.parentNode.nextSibling.querySelector("input").focus();
        }

        if (element.value === "" && element.parentNode.previousSibling) {
            element.parentNode.previousSibling.querySelector("input").focus();
        }
    }

    const handleOtpConfirm = async () => { 

        let mobile_number = "+88" + phone?.replaceAll(" ","");
        if( mobile_number.length !== 14 ) {
            openSnackbar("Please enter valid phone number.");
            setOtp(new Array(6).fill(""));
            currentPage("step1");
            return;
        }

        let otpString = otp.join()?.replaceAll(",","");
        if( otpString?.length !== 6 ) {
            openSnackbar("Please enter a valid OTP.");
            return;
        }


        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            mobile_number: mobile_number,
            otp: otpString,
            is_save: (isSaved ? 1 : 0)
        };


        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/verify-otp`,
                payload
            );

            if (res.data.code === 200) {
                setCurrentPage("step3");
                setTimeout(()=>{
                    $("#pin-0").focus();
                }, 1000);
                return;
            }
            

            showErrorMessages(res.data.code, res.data.message);
        }
        catch(err) {
            showErrorMessages(400);
        }
    }

    const handleTokenOtpConfirm = async () => {

        let otpString = otp.join()?.replaceAll(",","");
        if( otpString?.length !== 6 ) {
            openSnackbar("Please enter valid OTP.");
            return;
        }


        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            payment_token: tokenizedPaymentKey,
            otp: otpString,
            is_save: 0
        };

        setWarningBox({
            ...warningBox, 
            status: 1,
            show: true,
            title: "Please Wait!",
            message: "Request is being processed."
        });

        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/verify-tokenized-otp`,
                payload
            );

            if (res.data.code === 200) {
                setCurrentPage("step3");
                setTimeout(()=>{
                    $("#pin-0").focus();
                }, 1000);

                return;
            }
            
            // Error
            showErrorMessages(422, "Sorry! OTP does not match.", "Invalid OTP");
        }
        catch(err) {
            let otp_expire = err?.response?.data?.data?.otp_expire ?? 0;
            if( otp_expire === 1 ) { 
                return showErrorMessages(422, "Sorry! OTP has been expire.", "Expire OTP");
            }

            showErrorMessages(422, "Sorry! OTP does not match.", "Invalid OTP");
        }
        finally {
            setWarningBox({
                ...warningBox, 
                show: false
            });
        }
    }

    const handleResendOtp = async () => { 
        setOtp(new Array(6).fill(""));

        if( tokenizedPaymentKey?.length > 0 ) {
            handleResendTokenOtp();
            return;
        }

        let mobile_number = "+88" + phone?.replaceAll(" ","");
        if( mobile_number.length !== 14 ) {
            openSnackbar("Please enter valid phone number !");
            setOtp(new Array(6).fill(""));
            currentPage("step1");
            return;
        }

        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            mobile_number: mobile_number,
            is_save: (isSaved ? 1 : 0)
        };

        setCurrentPage("step2");

        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/resent-otp`,
                payload
            );

            if (res.data.code === 200) {
                setIsResendOtp(true);
                setTimeout(()=>{
                    $("#pin-0").focus();
                }, 1000);


                openSnackbar('OTP resend successfully.');
                return;
            } 
            
            // Error
            showErrorMessages(404);
        }
        catch(err) {
            alert(err);
        }
    }

    const handleResendTokenOtp = async () => {
        setOtp(new Array(6).fill(""));

        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            payment_token: tokenizedPaymentKey,
            is_save: 0
        };


        setCurrentPage("step2");

        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/resent-tokenized-otp`,
                payload
            );

            if (res.data.code === 200) {
                setIsResendOtp(true);
                setTimeout(()=>{
                    $("#pin-0").focus();
                }, 1000);


                openSnackbar('OTP resend successfully.');
                $("#otp-0").focus();
                return;
            } 
            
            // Error
            showErrorMessages(404);
        }
        catch(err) {
            showErrorMessages(404);
        }
    }

    // PIN Handler
    const [pin, setPin] = useState(new Array(4).fill(""));
    var handlePinChange = (element, index) => {
        if(isNaN(element.value)) {
            return false;
        }

        setPin([...pin.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.value !== "" && element.parentNode.nextSibling) {
            element.parentNode.nextSibling.querySelector("input").focus();
        }

        if (element.value === "" && element.parentNode.previousSibling) {
            element.parentNode.previousSibling.querySelector("input").focus();
        }
    }

    // Handle Payment
    const handlePinConfirm = async () => {

        let mobile_number = "+88" + phone?.replaceAll(" ","");
        if( mobile_number.length !== 14 ) {
            openSnackbar("Please enter valid phone number !");
            setOtp(new Array(6).fill(""));
            currentPage("step1");
            return;
        }

        let otpString = otp.join()?.replaceAll(",","");
        if( otpString?.length !== 6 ) {
            openSnackbar("Please enter valid OTP.");
            setOtp(new Array(6).fill(""));
            currentPage("step2");
            return;
        }

        let pinString = pin.join()?.replaceAll(",","");
        if( pinString?.length !== 4 ) {
            openSnackbar("Please enter valid PIN.");
            setPin(new Array(4).fill(""));
            setTimeout(()=>{
                $("#pin-0").focus();
            }, 1000);

            return;
        }


        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            mobile_number: mobile_number,
            otp: otpString,
            pin: pinString,
            is_save: (isSaved ? 1 : 0)
        };


        // Loader will appear
        setWarningBox(
            {
                ...warningBox, 
                status: 1,
                show: true,
                title: "Please Wait!",
                message: "Request is being processed.",
                otpInvalid: false
            }
        );
        

        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/execute`,
                payload
            );


            if (res.data.code === 200) {
                let s_url = new URL(info.merchant.redirect_urls.success);
                s_url.searchParams.append("order_id", info?.order.id);
                window.location.assign(s_url);
                return;
            }

            return showErrorMessages(500);
        }
        catch(err) {
            // let msg = err?.response?.data?.messages[0] ?? "A problem occur. Please try again.";
            let is_pin_expire = err?.response?.data?.data?.pin_expire ?? false;
            if( is_pin_expire ) {
                return showErrorMessages(403, "Sorry! PIN does not match.", "Invalid PIN");
            }
            let resData = err?.response?.data;
            let otp_issue = resData?.data?.otp ?? 0;
            if( otp_issue === 1 ) {
                window.location.reload(true);
                return showErrorMessages(422, "Sorry! OTP does not match.", "Invalid OTP");
            }

            let pin_issue = resData?.data?.pin ?? 0;
            if( pin_issue === 1 ) {
                return showErrorMessages(403);
            }

            resData = JSON.parse(resData?.data);

            setWarningBox({...warningBox, show: false});
            let is_low_balance = resData?.data?.low_balance ?? false;
            if( is_low_balance === true ) {
                let user_wallet_balance = resData?.data?.balance ?? null;
                if( user_wallet_balance !== null ) {
                    setUserWalletBalance(Math.floor(user_wallet_balance));
                }

                return setShowCards(true);
            }


            showErrorMessages(500);
        }
    }

    const handlePinConfirmWithOtp = async () => {
        
        let otpString = otp.join()?.replaceAll(",","");
        if( otpString?.length !== 6 ) {
            openSnackbar("Please enter valid OTP.");
            setOtp(new Array(6).fill(""));
            currentPage("step2");
            return;
        }

        let pinString = pin.join()?.replaceAll(",","");
        if( pinString?.length !== 4 ) {
            openSnackbar("Please enter valid PIN.");
            setPin(new Array(4).fill(""));
            setTimeout(()=>{
                $("#pin-0").focus();
            }, 1000);

            return;
        }


        setWarningBox({...warningBox, show: true});

        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            pin: pinString,
            payment_token: tokenizedPaymentKey,
            otp: otpString,
            is_save: 0
        };


        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/execute-token`,
                payload
            );


            if (res.data.code === 200) {
                let s_url = new URL(info.merchant.redirect_urls.success);
                s_url.searchParams.append("order_id", info?.order.id);
                window.location.assign(s_url);
                return;
            }
        }
        catch(err) {
            let resData = err?.response?.data;

            let otp_issue = resData?.data?.otp ?? 0;
            if( otp_issue === 1 ) {
                return showErrorMessages(422, "Sorry! OTP does not match.", "Invalid OTP");
            }


            let pin_issue = resData?.data?.pin ?? 0;
            if( pin_issue === 1 ) {
                return showErrorMessages(403);
            }


            let is_low_balance = resData?.data ?? "";
            
            if( is_low_balance?.search("low_balance") ) {
                return setShowCards(true);
            }

            showErrorMessages(500);
        }
        finally {
            // Hide loader
            setWarningBox({...warningBox, show: false});
        }
    }

    const handlePinConfirmWithoutOtp = async () => { 
        let pinString = pin.join()?.replaceAll(",","");
        if( pinString?.length !== 4 ) {
            openSnackbar("Please enter valid PIN.");
            setPin(new Array(4).fill(""));
            setTimeout(()=>{
                $("#pin-0").focus();
            }, 1000);

            return;
        }


        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            pin: pinString,
            payment_token: tokenizedPaymentKey,
            is_save: 0
        };


        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/execute-token-without-otp`,
                payload
            );


            if (res.data.code === 200) {
                let s_url = new URL(info.merchant.redirect_urls.success);
                s_url.searchParams.append("order_id", info?.order.id);
                window.location.assign(s_url);
                return;
            }
        }
        catch(err) {
            let resData = err?.response;
            console.log(resData);

            // let pin_issue = resData?.data?.pin ?? 0;
            // if( pin_issue === 1 ) {
            //     return showErrorMessages(403);
            // }


            // let is_low_balance = resData?.data ?? "";
            // if( is_low_balance?.search("low_balance") ) {
            //     return setShowCards(true);
            // }

            // showErrorMessages(500);

            // let is_pin_expire = err?.response?.data?.data?.pin_expire ?? false;
            // if( is_pin_expire ) {
            //     window.location.reload(true);
            // }

            // let is_low_balance = err?.response?.data?.data ?? "";
            // if( is_low_balance?.search("low_balance") ) {
            //     setShowCards(true);
            //     return;
            // }
            // else {
            //     alert(msg);
            // }

        }
    }
    // PIN Handler End


    // Enter Press Handler
    const pressEnter = (e) => {
        if( e.key === 'Enter' ) {
            if( warningBox.show === true ) {
                if( warningBox.status === 0 ) {
                    setWarningBox({...warningBox, show: false});
                }

                return;
            }

            handleConfirm();
        }
    }


    // Tokenize Payment Initiative
    const paymentViaSavedWallet = async (key, account) => {
        if( key?.length === 0 ) {
            showErrorMessages(400, "Sorry! Could not found a valid account.", "Invalid Account");
            return;
        }

        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            payment_token: key,
            is_save: 0
        };

        
        try {
            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/initiation-token`,
                payload
            );
            
            if(res?.data?.code === 200) {

                // Check Page....
                let data = res?.data?.data ?? "";
                const page = data?.page ?? "";

                if( data?.private_key?.length === 0 ) {
                    showErrorMessages(401);
                    setCurrentPage('step1');
                    return;
                }

                setTokenizedPaymentKey(data?.private_key ?? "");
                if( page === "otp" ) {
                    setMaskingPhone(account);
                    setOtpTime(process.env.REACT_APP_RESEND_OTP_TIMER);
                    setCurrentPage("step2");
                    setTimeout(()=>{
                        $("#otp-0").focus();
                    }, 1000);
                }

                if( page === "pin") {
                    setIsOtpRequired(false);
                    setMaskingPhone(account);
                    setCurrentPage("step3");
                    setTimeout(()=> {
                        $("#pin-0").focus();
                    }, 1000);
                }

                return;
            }

            showErrorMessages(401);
            return;
        }
        catch (error) {
            showErrorMessages(401);
            return;
        }
        finally {
            setIsShowSavedAccount(false);
        }
    }


    // SAVE WALLET OPTION CLICK
    const saveWalletOptionClick = () => {
        if(isSaved) {
            setIsSaved(false);
            return;
        }


        setSavedWalletAgreement(true);
        return;
    }

    const saveWalletOptionConfirmYes = () => {
        setSavedWalletAgreement(false);
        setIsSaved(true);
    }

    const showErrorMessages = (code, message="Sorry! Could not proceed this request right now.", title="Error!") => {
        switch (code) {
            case 400:
                setWarningBox({...warningBox, show: true, status: 0, title: "Invalid OTP", message: "Sorry! OTP doesn't match."});
                break;
            case 401:
                setWarningBox({...warningBox, show: true, status: 0, title: "Invalid Payment", message: 'Sorry! Could not initiate payment process right now.'});
                break;
            case 403:
                setPin(new Array(4).fill(""));
                setTimeout(()=>{
                    $("#pin-0").focus();
                }, 1000);
                setWarningBox({...warningBox, show: true, status: 0, title: "Invalid PIN", message: "Sorry! Pin doesn't match."});
                break;
            case 402:
                setWarningBox({...warningBox, show: true, status: 0, title: "Insufficient Fund", message: "Sorry, you don’t have sufficient balance."});
                break;
            case 404:
                setWarningBox({...warningBox, show: true, status: 0, title: "Error!", message: 'Sorry! Could not proceed this request right now.'});
                break;
            case 406:
                setWarningBox({...warningBox, show: true, status: 4, title: "Error!", message: 'Sorry! Payment gateway information not found.'});
                break;
            case 422:
                setWarningBox({...warningBox, show: true, status: 4, title: title, message: message, otpInvalid: true});
                break;
            case 429:
                setWarningBox({...warningBox, show: true, status: 4, title: "Too many requests!", message: "You are not allowed for further process right now."});
                break;
            case 500:
                setWarningBox({...warningBox, show: true, status: 0, title: "Server Error!", message: "Sorry! An unexpected error occur. Please try again."});
                break;
            default:
                setWarningBox({...warningBox, show: true, status: 0, title: title, message: message});
        }

        return;
    }


    const selectPaymentOption = (index) => {
        $(".payment_options > img").not($(".payment_options > img").eq(index)).removeClass('selected');
        $(".payment_options>img").eq(index).toggleClass('selected');

        if ($(".payment_options > img.selected").length === 0) { 
            setSelectedPaymentOption("");
        }
        else {
            if( index === 0 ) {
                setSelectedPaymentOption("Visa");
            }
            else if( index === 1 ) {
                setSelectedPaymentOption("MasterCard");
            }
            else if( index === 2 ) {
                setSelectedPaymentOption("Amex");
            }
            else {
                setSelectedPaymentOption("");
            }
        }
    }


    const paymentExecute = async () => {
        
        let mobile_number = "+88" + phone?.replaceAll(" ","");
        if( mobile_number.length !== 14 ) {
            openSnackbar("Please enter valid phone number !");
            setOtp(new Array(6).fill(""));
            currentPage("step1");
            return;
        }

        let otpString = otp.join()?.replaceAll(",","");
        if( otpString?.length !== 6 ) {
            openSnackbar("Please enter valid OTP.");
            setOtp(new Array(6).fill(""));
            currentPage("step2");
            return;
        }

        let pinString = pin.join()?.replaceAll(",","");
        if( pinString?.length !== 4 ) {
            openSnackbar("Please enter valid PIN.");
            setPin(new Array(4).fill(""));
            setTimeout(()=>{
                $("#pin-0").focus();
            }, 1000);

            return;
        }

        const payload = {
            order_id: info.order.id,
            token: paymentToken,
            mobile_number: mobile_number,
            otp: otpString,
            pin: pinString,
            is_save: (isSaved ? 1 : 0),
            'card_type': selectedPaymentOption?.toString().toLowerCase()
        };

        
        try {
            // Loader will appear
            setWarningBox(
                {
                    ...warningBox, 
                    status: 1,
                    show: true,
                    title: "Please Wait!",
                    message: "Payment request is being processed.",
                    otpInvalid: false
                }
            );


            let res = await axios.post(
                `${process.env.REACT_APP_PAYMENT_GATEWAY_URL}/execute-add-money-via-card`,
                payload
            );

            if(res?.data?.code === 200) {
                let d = res?.data?.data;

                let payment_url = d?.url ?? "";
                if( payment_url !== "" ) {
                    return window.location.assign(payment_url);
                }

                showErrorMessages(100, d?.messages[0] ?? "A problem occur. Please try again.", 'ERR_MULTIPLE_REQUEST');
                return;
            }

            showErrorMessages(100, res?.data?.messages[0] ?? "A problem occur. Please try again.");
            return;
        }
        catch (error) {
            let msg = error?.response?.data?.messages[0] ?? "A problem occur. Please try again.";
            showErrorMessages(100, msg);
            return;
        }
        finally {
            setWarningBox(
                {
                    ...warningBox, 
                    show: false,
                }
            );
        }
    }



    
    return (
        <div className="payment body">
            

            {(currentPage==="step2") && 
                <div className='info-box'>
                    <img src={InfoIcon} alt="Info" />
                    <p>
                        We have sent an OTP to <span style={{fontWeight: 475}}>{maskingPhone}</span>. Please enter the number below
                    </p>
                </div>
            }


            {/* Save wallet agreement box show */}
            {(info?.merchant && savedWalletAgreement) && 
                <>
                    <div className="overlay"></div>
                    <div id="saved_wallet_lists" >
                        <div style={{borderRadius: "5px"}}>
                            {/* <span id="swl_title">
                                Save ST Pay Account
                            </span> */}

                            <span id="swl_sub_title" style={{marginTop: "5px", fontSize: "14px", lineHeight: "25px", textAlign: "center"}}>
                                Are you sure you want to save this wallet?
                            
                                <div style={{display:"flex", marginTop: "15px", position: "relative", border: "none", padding: "0px", justifyContent: "center"}}>
                                    <button type='button' onClick={()=>setSavedWalletAgreement((prev)=>{return !prev})} style={{background: "#FF4C4C", paddingBlock: "3px", width: "100px", border: "none", borderRadius: "5px", color:"#FFF"}}>Cancel</button>
                                    
                                    <button type='button' onClick={saveWalletOptionConfirmYes} style={{background: "#04AA6D", width: "100px", border: "none", borderRadius: "5px", color:"#FFF", marginLeft: "10px"}}>Confirm</button>
                                </div>
                            </span>

                            
                        </div>
                    </div>
                </>
            }

            {/* Saved Wallet Lists */}
            {(info?.merchant && isShowSavedAccount) && 
                <>
                    <div className="overlay"></div>
                    <div id="saved_wallet_lists">
                        <div>
                            <span id="swl_title">
                                Saved Account
                                <img src={CancelIcon} onClick={()=>setIsShowSavedAccount((prev)=>{return !prev})} alt='Cancel'></img>
                            </span>
                            <span id="swl_sub_title">You can use saved accounts from this list.</span>
                            
                            <span id="swl_body" style={{display: 'block'}}>
                                {(info.saved_wallet.map((val, i)=>{
                                    return (
                                        <p style={{marginBottom: "5px", border: "1px solid #d3e4ed"}} onClick={()=>paymentViaSavedWallet(val?.private_key, val?.wallet_no?.replace("+880","0"))} key={i}>
                                            <img src={val?.photo} alt='Img' />
                                            <span style={{display: "flex", flexDirection:"column", justifyContent:"center"}}>
                                                <span className='swl_w'>{val?.wallet_no?.replace("+880","0")}</span>
                                                <span className='swl_n'>{val?.name ?? val?.nid_name ?? "-"}</span>
                                            </span>
                                        </p>
                                    );
                                }))}
                                
                            </span>
                        </div>
                    </div>
                </>
            }

            {(info?.merchant && showCards) && 
            <>
                <div className="overlay"></div>
                <div id="saved_wallet_lists">
                    <div>
                        <span id="swl_title" style={{color: "#ea001b"}}>
                            Insufficient Balance
                        </span>
                        
                        

                        {/* Payment Options */}
                        <span className='insufficient_details' style={{marginTop: "10px"}}>
                            <span>Invoice Amount</span>
                            <span>৳ {info?.order?.total_payable?.amount}</span>
                        </span>
                        <span className='insufficient_details'>
                            <span>ST Pay Wallet Balance</span>
                            <span>৳ {String(userWalletBalance).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                        </span>
                        <span className='insufficient_details' style={{marginTop: "5px"}}>
                            <span>Insufficient Amount</span>
                            <span style={{color: "red"}}>৳ {String(info?.order?.total_payable?.amount - userWalletBalance).replace(/(.)(?=(\d{3})+$)/g,'$1,')}</span>
                        </span>


                        <span id="swl_sub_title" style={{marginTop: "10px"}}>
                            Please select one of the available payment options to proceed.
                        </span>
                        <span id="swl_body" style={{marginTop: "-5px"}}>
                            
                            <span className='payment_options' onClick={()=>selectPaymentOption(0)}>
                                <img src={VisaIcon} alt="Visa" title='Visa' />
                                <span className='caption'>VISA</span>
                            </span>

                            <span className='payment_options' onClick={()=>selectPaymentOption(1)}>
                                <img src={MastercardIcon} alt="Mastercard" title='Mastercard' />
                                <span className='caption'>Mastercard</span>
                            </span>

                            <span className='payment_options' onClick={()=>selectPaymentOption(2)}>
                                <img src={AmexIcon} alt="Amex" title='Amex' />
                                <span className='caption'>Amex</span>
                            </span>


                            {/* <span className='payment_options'>
                                <img src={NagadIcon} alt="Nagad" title='Nagad'  onClick={()=>selectPaymentOption(3)} />
                                <span className='caption'>Nagad</span>
                            </span> */}


                            
                        </span>
                            
                        <p style={{backgroundColor: 'transparent', cursor: "default"}}>Insufficient amount will be deduct from your selected option.</p>

                        {(selectedPaymentOption !== "") ? 
                            <span style={{display: "flex", flexDirection: "row", paddingInline: "10px", "gap": "7px"}}>
                                <span 
                                onClick={paymentExecute}
                                style={{ margin: "0px 0px 20px 0px", textAlign: "center", color: "rgba(255, 255, 255, 1)", 
                                background: "rgba(92, 167, 255, 1)", border: "1px solid rgba(255, 255, 255, .1)",
                                paddingBlock: "10px", fontSize: "15px", borderRadius: "7px", fontWeight: "475",
                                cursor: "pointer", display: "block", "width": "100%"
                                }}>Continue with {selectedPaymentOption}</span>
                            </span>
                        :
                            <span style={{display: "flex", flexDirection: "row", paddingInline: "10px", "gap": "7px"}}>
                                <span 
                                onClick={handleCancel}
                                style={{ margin: "0px 0px 20px 0px", textAlign: "center", color: "rgba(239, 85, 80, 1)", 
                                background: "rgba(252, 236, 235, 1)", border: "1px solid rgb(231 211 210 / 30%)",
                                paddingBlock: "10px", fontSize: "15px", borderRadius: "7px", fontWeight: "475",
                                cursor: "pointer", display: "block", "width": "100%"
                                }}>Cancel</span>

                                <span 
                                onClick={handleTryAgain}
                                style={{ margin: "0px 0px 20px 0px", textAlign: "center", color: "rgba(255, 255, 255, 1)", 
                                background: "rgba(92, 167, 255, 1)", border: "1px solid rgba(255, 255, 255, .1)",
                                paddingBlock: "10px", fontSize: "15px", borderRadius: "7px", fontWeight: "475",
                                cursor: "pointer", display: "block", "width": "100%"
                                }}>Try again</span>
                            </span>
                        }

                    </div>
                </div>
            </>
            }


            
            <div id="main-box">
                <div className='form'>

                    
                    {/* PGW Details */}
                    <div className="logo w-full py-3 text-center bg-[var(--dark-75, #EBF0F5)]">
                        <img src={STPayLogo} id="Logo" alt="ST Pay logo" className='max-h-[40px]'/>
                    </div>

                    {/* Merchant Details */}
                    {(info?.merchant) && 
                        <div className='bg-white'>
                            <div className='content header px-3 py-3'>
                                <div className="top-left" style={{alignItems: "center"}}>
                                    {(info?.merchant?.logo) && 
                                        <img src={info?.merchant?.logo} alt="Merchant Logo" className='me-2'
                                        style={{maxWidth: "70px", height: "46px", border: "1px solid rgba(23, 130, 253, 0.1)", borderRadius: "5px"}} />
                                    }

                                    <div>
                                        <p className="merchant_name">
                                            {info?.merchant?.name}
                                        </p>
                                        <p className='invoice'>
                                            Order Id : {info?.order?.id}
                                        </p>
                                    </div>
                                </div>

                                <h3 id="order_amount" className="fs-18">৳ {info?.order?.total_payable?.amount}</h3>
                            </div>

                            

                            {/* Option with QR Code */}
                            <div id="option_tab">
                                {(isQrPayment) ? <>
                                    <div onClick={()=>setIsQrPayment(false)}>Use ST Pay Account No</div>
                                    <div className='current' onClick={()=>setIsQrPayment(true)}>Scan QR Code</div>
                                </> : <>
                                    <div className='current' onClick={()=>setIsQrPayment(false)}>Use ST Pay Account No</div>
                                    <div onClick={()=>setIsQrPayment(true)}>Scan QR Code</div>
                                </>}
                            </div>

                        </div>
                    }
                    

                    
                    {/* Form Input */}
                    {info?.merchant &&
                        <div className='flex p-3 bg-[#EBF0F5]' style={{alignItems: "center"}}>
                            {(currentPage==="step1") && 
                                <>
                                    {(!isQrPayment) ? 
                                    <span>
                                        {/* Account No */}
                                        <div id="phone-box" className='p-3 bg-white' style={{borderRadius: "8px"}}>
                                            <label>ST Pay Account Number</label>
                                            <div style={{position: "relative"}}>
                                                <span className="form-input-prefix">+88</span>
                                                <input type='text' inputMode="numeric" pattern="[0-9]" onKeyDown={(e)=>pressEnter(e)} onChange={(event)=>enterPhone(event.currentTarget)} value={phone} id="phone_input" placeholder='0000 000 0000' className='form-input' />
                                            </div>
                                        </div>

                                        {/* Terms & Conditions */}
                                        <p className='terms'>
                                            By clicking/tapping “Confirm” you are agreeing to our<br/>
                                            <Link to="https://stpay.net/terms-condition">Terms &amp; Conditions.</Link>
                                        </p>
                                    </span>
                                    :
                                    <div id="qr_div">
                                        <img src={qr_image} height={146} width={146} alt='QR Code' />

                                        {/* <StyledQRCode></StyledQRCode> */}

                                        {/* <CustomQRCode link={info.order?.qr_text}></CustomQRCode> */}

                                        {/* <QRCode
                                            value={info.order?.qr_text}
                                            imageSettings={{
                                                src: "https://distribution.deshipay.com/img/stpay.png", // Replace with your logo URL
                                                height: 40,  // Height of the logo inside the QR code
                                                width: 70,   // Width of the logo inside the QR code
                                                excavation: true // Excavates area under logo to keep QR scannable
                                            }}
                                            size={180} // QR Code size
                                            fgColor="#073E67" // QR Code color (foreground color)
                                            bgColor="#ffffff" // QR Code background color
                                            level="Q" // Error correction level (L, M, Q, H)
                                            includeMargin={true} // Add margin around the QR Code
                                            renderAs="svg" // Render as SVG for scalable QR code
                                        />  */}
                                        
                                        

                                    </div>}
                                </>
                            }

                            {/* OTP */}
                            {(currentPage==="step2") && 
                                <>
                                    {/* OTP */}
                                    <div id="phone-box" className='p-3 bg-white' style={{borderRadius: "8px"}}>
                                        <label>Enter OTP here</label>
                                        <div className='otp-input-box'>
                                            {otp.map((data, index) => {
                                                return (
                                                    <span key={index}>
                                                        <input
                                                            id={`otp-`+index}
                                                            inputMode="numeric"
                                                            type="text"
                                                            name="otp[]"
                                                            maxLength="1"
                                                            key={index}
                                                            value={data}
                                                            onChange={(e) => {
                                                                handleOtpChange(e.target, index);
                                                            }}
                                                            placeholder='-'
                                                            onFocus={(e) => e.target.select()}
                                                            onKeyDown={(e)=>pressEnter(e)}
                                                            required
                                                        />
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <p className='terms'>
                                        {(isResendOtp === false) && 
                                            <>
                                            Didn’t get the code yet?
                                            {(otpTime > 0) ? 
                                                <div style={{marginTop: "7px", fontSize: "15px"}}>Resend in <span style={{fontWeight: "475"}}>{formatTime(otpTime)}</span></div>
                                            :
                                                <div style={{marginTop: "7px"}}>
                                                    <span onClick={handleResendOtp} style={{fontWeight: "500", color: "#073E67", cursor: "pointer", textDecoration: "none"}}>Resend OTP</span>
                                                </div>
                                            }
                                            </>
                                        }
                                    </p>
                                </>
                            }

                            {/* PIN */}
                            {(currentPage==="step3") && 
                                <>
                                    {/* PIN */}
                                    <div id="phone-box" className='p-3 bg-white' style={{borderRadius: "8px"}}>
                                        <label>Enter ST Pay Account PIN</label>
                                        <div className='otp-input-box'>
                                            {pin.map((data, index) => {
                                                return (
                                                    <span key={index}>
                                                        <input
                                                            id={`pin-`+index}
                                                            inputMode="numeric"
                                                            type="password"
                                                            name="pin[]"
                                                            maxLength="1"
                                                            key={index}
                                                            value={data}
                                                            onChange={(e) => {
                                                                handlePinChange(e.target, index);
                                                            }}
                                                            placeholder=""
                                                            onFocus={(e) => e.target.select()}
                                                            onKeyDown={(e)=>pressEnter(e)}
                                                            required
                                                        />
                                                    </span>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </>
                            }



                        </div>
                    }

                    
                    {/* Save Option */}
                    {(!isQrPayment) && <> 
                    {(currentPage==="step1" && info?.saved_wallet?.length < 5 && info?.merchant?.save_wallet_permission === 'yes') && 
                        <div id="save_option_div">
                            <div className='option_label'>
                                <p className='title'>Save this wallet</p>
                                {/* <p className='sub_title'>You can save maximum 5 wallets</p> */}
                            </div>
                            <div className='option_radio'>
                                <label className="toggle">
                                    <input className="toggle-checkbox" type="checkbox" checked={isSaved} onChange={saveWalletOptionClick}  />
                                    <div className="toggle-switch"></div>
                                    <span className="toggle-label"></span>
                                </label>
                            </div>
                        </div>
                    }
                    </>}
                </div>

                {(warningBox?.show) && 
                <>
                    <div className='overlay'></div>
                    <div className='response-message'>

                        {(warningBox?.status===0 || warningBox?.status===4) && 
                            <img src={WarningIcon} alt='Warning' />
                        }

                        {(warningBox?.status===1) && 
                            <img src={loader} alt='Loading...' style={{height: "75px"}} />
                        }

                        {(warningBox?.status===2) && 
                            <img src={SuccessIcon} alt='Success' />
                        }
                        
                        <p style={{fontSize: "14px", fontWeight: "525", marginTop: "15px"}}>{warningBox?.title ?? "Error"}</p>
                        <p style={{fontSize: "13px", marginTop: "4px"}}>{warningBox?.message ?? "Internal server error !"}</p>
                        
                        
                        {/* Error */}
                        {(warningBox?.status===0) && 
                            <div className='action_buttons' style={{marginTop: "10px", padding: "10px 5px 0px"}}>
                                <div onClick={()=>setWarningBox({...warningBox, status: 0, show: false, title: "", message: ""})} className='btn-submit' style={{width: "100%"}}>Try Again</div>
                            </div>
                        }

                        {(warningBox?.status===4) && 
                            <div className='action_buttons' style={{marginTop: "10px", padding: "10px 5px 0px"}}>
                                <div onClick={handleCancel} className='btn-cancel' style={{width: "100%", background: "rgb(239 85 80)", color: "white"}}>Cancel</div>
                            </div>
                        }
                    </div>
                </>}
                

                {/* Saved Accounts */}
                {(currentPage==="step1" && info?.saved_wallet?.length > 0 && info?.merchant ) && 
                <div className='saved_wallet_div'>
                    <div id='saved_wallet_div_header'>
                        <p><strong>Select Account</strong></p>
                        <p><strong>{info?.saved_wallet?.length}</strong> out of <strong>5</strong></p>
                    </div>
                    <div className='pt-2'>
                        <div id='saved_wallet_div_selector' onClick={()=>setIsShowSavedAccount((prev)=>{return !prev})}>
                            <option>Select from saved accounts</option>
                        </div>
                    </div>
                </div>
                }
                
            </div>
                
                
                
                {/* Footer */}
                <div className='saved_wallet_div footer'>
                    <div className='count_down'>
                        This page will timed out in 
                        <span id="counter">
                            {formatTime(time)} 
                            &nbsp;{(time <= 60) ? <>minute</> : <>minutes</> }
                        </span>
                    </div>

                    
                    <div className='action_buttons'>
                        {(!showCards) && 
                            <>
                                <button type='button' onClick={handleCancel} className='btn-cancel'>Cancel</button>
                                <button type='button' onClick={handleConfirm} className='btn-submit'>Proceed</button>
                            </>
                        }
                    </div>
                
                </div>
            


        </div>
    );
    
}
